import { render, staticRenderFns } from "./TgServiceBtn.vue?vue&type=template&id=44961b4e"
import script from "./TgServiceBtn.vue?vue&type=script&lang=js"
export * from "./TgServiceBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports